import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { Onboarding, TcAcceptResponse } from "@redotech/redo-model/onboarding";

export async function getCurrentOnboarding(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<Onboarding> {
  const response = await client.client.get("onboarding", {
    headers: client.authorization(),
    params: { _t: Date.now() },
    signal,
  });
  return response.data;
}

export async function onboardingTc(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<TcAcceptResponse> {
  const response = await client.client.put(
    "onboarding/tc",
    {},
    { headers: client.authorization(), signal },
  );
  return response.data;
}
